import React, { useEffect } from "react";
import { Image } from "react-bootstrap";
import {
  Container,
  Form,
  Button,
  Divider,
  Panel,
  Input,
  PasswordInput,
  HStack,
} from "rsuite";
import { notification } from "antd";
import moment from "moment/moment";
import { useState } from "react";
import { confApp } from "../CONF_APP";
import axios from "../axiosIn";

export const App = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check
  const [loading, setLoading] = useState(false);
  const [codNegocio, setCodNegocio] = useState("");
  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [api, contextHolder] = notification.useNotification();

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const setCookie = (name, value, hours) => {
    document.cookie = `${name}=${value};`;
    document.cookie = `expira=${moment().add(hours, "h").format()};`;
    document.cookie = `sessionID=${crypto.randomUUID()};`;
  };

  const handleSubmit = async () => {
    var url = "Login";

    setLoading(true);
    const data = {
      codNegocio: codNegocio,
      user: usuario,
      pwd: password,
    };

    await axios
      .post(url, data)
      .then((res) => {
        if (res.data === 0) {
          setLoading(false);
          errorNotificaction("Inicio de sesión", "Los datos no son correctos, valida tu información.");
          return;
        }

        if (res.data === -1) {
          setLoading(false);
          errorNotificaction("Usuario","El usuario se encuentra inactivo.");
          return;
        }

        if (res.data === -2) {
          setLoading(false);
          errorNotificaction("Inicio de sesión", "El usuario no cuenta con permisos para la aplicación.");
          return;
        }

        const auth = {
          id: res.data.id,
          codNegocio: codNegocio,
          idUser: res.data.idUser,
          idMedico: res.data.idMedico,
          medico: res.data.medico,
          idEnf: res.data.idEnf,
          enfermera: res.data.enfermera,
          nefro: res.data.nefro,
          consultorio: res.data.consultorio,
          nombre: res.data.nombre,
          sesionIni: new Date().toISOString(),
          fecha: res.data.fecha,
          permisos: res.data.permisos,
          camposHojaEnf: res.data.camposValidHojaEnf,
          confApp: res.data.confApp,
        };

        localStorage.setItem("menu", JSON.stringify(res.data.menu));
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("auth", JSON.stringify(auth));
        var userUniq = `${res.data.id}${res.data.idUser}`;
        setCookie("user", userUniq, 20);
        setLoading(false);

        console.log(res.data.idEnf);

        if(res.data.idEnf > 0){
          window.location = `/#/App/Home/HojaEnfermeria`;  
        }else{
          if(res.data.idMedico > 0){
            window.location = `/#/App/Home/NotaMedica`;
          }else{
            window.location = `/#/App/Home`;
          } 
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        errorNotificaction(err.name, err);
      });
  };

  const handleInput = (e) => {
    setCodNegocio(e);
  };


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Update on resize
    };
    window.addEventListener("resize", handleResize);
    // Set up an interval to update the time every second

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
    };
  }, []); // Empty dependency array ensures this effect runs only once on mount

  return (
    <Container>
      {contextHolder}
      {!isMobile ? (
        <HStack style={{ verticalAlign: "center" }}>
          <div className="col-lg-5 col-md-5 col-sm-5">
            <Panel
              bordered
              shaded
              style={{ height: "100vh", padding: "100px", paddingTop: "180px" }}
            >
              <HStack align={"center"}>
                <Image
                  src="/Images/Logo.png"
                  style={{
                    height: 220,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                />
              </HStack>
              <div>
                <Form fluid onSubmit={handleSubmit}>
                  <Form.Group>
                    <Input
                      name="codNegocio"
                      value={codNegocio}
                      placeholder="Código de Negocio"
                      style={{ borderColor: "#08086E" }}
                      onChange={(e) => handleInput(e)}
                      required
                    />
                  </Form.Group>

                  <Form.Group>
                    <Input
                      name="name"
                      placeholder="Usuario"
                      style={{ borderColor: "#08086E" }}
                      onChange={(e) => setUsuario(e)}
                      value={usuario}
                      required
                    />
                  </Form.Group>

                  <Form.Group>
                    <PasswordInput
                      name="password"
                      value={password}
                      style={{ borderColor: "#08086E" }}
                      placeholder="Contraseña"
                      onChange={(e) => setPassword(e)}
                      required
                    />
                  </Form.Group>

                  <br></br>

                  <Button
                    appearance="primary"
                    loading={loading}
                    block
                    type="submit"
                  >
                    Ingresar
                  </Button>
                </Form>

                <br></br>

                <Divider style={{ fontSize: "12px", color: "#CCCACA" }}>
                  <b>Version: {confApp.VERSION}</b>
                </Divider>
                <HStack align={"center"}>
                  <a
                    href="https://www.radyxxa.com.mx"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: "blue",
                      textDecoration: "none",
                      fontSize: "9px",
                    }}
                  >
                    Designed by &nbsp;<i>RADYXXA</i>
                  </a>
                </HStack>
              </div>
            </Panel>
          </div>
          <div className="col-lg-7 col-md-7 col-sm-7">
            <Image
              src="Images/backLogin.jpg"
              style={{ objectFit: "cover", height: "100vh", width: "100%" }}
            ></Image>
          </div>
        </HStack>
      ) : (
        <Panel
          bordered
          shaded
          style={{ height: "100vh", paddingBottom: "25%", paddingTop: "25%" }}
        >
          <HStack
            align={"center"}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Image src="/Images/Logo.png" style={{ height: 180, display: 'flex', justifyContent: 'center', alignItems: 'center' }} />
          </HStack>
          <br></br>
          <div>
            <Form fluid onSubmit={handleSubmit}>
              <Form.Group>
                <Input
                  name="codNegocio"
                  value={codNegocio}
                  placeholder="Código de Negocio"
                  onChange={(e) => handleInput(e)}
                  required
                />
              </Form.Group>

              <Form.Group>
                <Input
                  name="name"
                  placeholder="Usuario"
                  onChange={(e) => setUsuario(e)}
                  value={usuario}
                  required
                />
              </Form.Group>

              <Form.Group>
                <PasswordInput
                  name="password"
                  placeholder="Contraseña"
                  value={password}
                  onChange={(e) => setPassword(e)}
                  required
                />
              </Form.Group>

              <br></br>

              <Button appearance="primary" loading={loading} block type="submit">
                Ingresar
              </Button>
            </Form>

            <br></br>

            <Divider style={{ fontSize: "12px", color: "#CCCACA" }}>
              <b>Version: {confApp.VERSION}</b>
            </Divider>
            <center>
              <a
                href="https://www.radyxxa.com.mx"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "blue",
                  textDecoration: "none",
                  fontSize: "9px",
                }}
              >
                Designed by &nbsp;<i>RADYXXA</i>
              </a>
            </center>
          </div>
        </Panel>
      )}
    </Container>
  );
};
